import styled from "styled-components"

const ResourceTableRowDataLink = styled.a`
	cursor: pointer;
	color: rgb(3, 121, 201);
	font-weight: 500;
	text-decoration: underline;
`

export default ResourceTableRowDataLink